import GoogleWorkspaceAPI from '../../api/googleWorkspace';

export const state = {
  connected: false,
  googleEmail: null,
  uiFlags: {
    isFetching: false,
    isConnecting: false,
  },
};

export const getters = {
  isConnected: $state => $state.connected,
  getGoogleEmail: $state => $state.googleEmail,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await GoogleWorkspaceAPI.status();
      commit('setStatus', data);
    } catch (error) {
      // Non-fatal: treat as disconnected so the sidebar can offer to connect.
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  connect: async ({ commit }) => {
    commit('setUIFlag', { isConnecting: true });
    try {
      const { data } = await GoogleWorkspaceAPI.connect();
      if (data.url) {
        window.location.href = data.url;
      }
    } finally {
      commit('setUIFlag', { isConnecting: false });
    }
  },

  disconnect: async ({ commit }) => {
    await GoogleWorkspaceAPI.disconnect();
    commit('setStatus', { connected: false, google_email: null });
  },
};

export const mutations = {
  setStatus($state, data) {
    $state.connected = Boolean(data.connected);
    $state.googleEmail = data.google_email || null;
  },
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
